import {useMemo} from 'react'

import {QrCodeBlock} from './primitives'
import {useQrSession, type UseQrSessionConfig} from './useQrSession'

interface QrSessionBlockProps extends UseQrSessionConfig {
  label?: React.ReactNode
  size?: number
  logo?: string
  logoSize?: number
}

export function QrSessionBlock({
  label,
  size,
  logo,
  logoSize,
  ...sessionConfig
}: QrSessionBlockProps) {
  const {
    qrCodeUrl,
    qrCodeValue,
    sessionStatus,
    isInitError,
    initErrorMessage,
    isStatusError,
    statusErrorMessage,
  } = useQrSession(sessionConfig)

  const isError = isInitError || isStatusError || sessionStatus === 'failed'

  const statusText = useMemo(() => {
    if (isInitError) {
      return initErrorMessage ?? 'Connection error. Please try again.'
    }
    if (isStatusError || sessionStatus === 'failed') {
      return statusErrorMessage ?? 'Connection error. Please try again.'
    }
    if (qrCodeUrl && sessionStatus !== 'completed') {
      return 'Waiting for QR code scan...'
    }
    return undefined
  }, [
    isInitError,
    initErrorMessage,
    isStatusError,
    statusErrorMessage,
    qrCodeUrl,
    sessionStatus,
  ])

  return (
    <QrCodeBlock
      label={label}
      qrCodeUrl={qrCodeUrl}
      qrCodeValue={qrCodeValue}
      logo={logo}
      logoSize={logoSize}
      statusText={statusText}
      statusVariant={isError ? 'error' : 'default'}
      size={size}
    />
  )
}
